<script>
  import options from './NavigationCard.options'
  const componentOptions = options
  export default componentOptions
</script>

<template>
  <a :href="result.url" class="be-navigation-card">
    <div>
      
      <div class="be-navigation-card__content-wrapper">
        <div class="be-content-card__image-area-wrapper">
          <figure class="be-image be-image--4-3">
            <div class="be-image__image-wrapper">
              <picture class="be-image__img">
                <img :src="result.imageSrc" :alt="result.imageAlt">
              </picture>
            </div>
          </figure>
        </div>

        <h3 class="be-font-heading-2 be-navigation-card__title">
          {{ result.title }}
        </h3>

        <div class="be-icon be-navigation-card__arrow">
          <svg role="presentation" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.75 11.726h-15M13.7 5.701l6.05 6.025-6.05 6.024" stroke="#2E7948" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>

    </div>
  </a>
</template>
